import React, { useEffect, useState } from "react";
import { string, number, arrayOf, bool, shape } from "prop-types";
import { Link } from "react-router-dom";
import { routerActions } from "connected-react-router";
import { connect, useDispatch } from "react-redux";

import * as configUtils from "util/config";
import { actions as depositsActions, selectors as depositsSelectors } from "reducers/deposits";
import isEmpty from "lodash/isEmpty";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import CustomText from "pages/_components/CustomText/CustomText";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import Button from "pages/_components/Button";
import EmptyScreenAlert from "pages/_components/EmptyScreenAlert/EmptyScreenAlert";
import TotalInvestedCapital from "./TotalInvestedCapital";
import { renewalActions } from "../constants";

const DepositList = ({ deposits, totalInvestedCapital, isDesktop }) => {
    const dispatch = useDispatch();
    const depositsPerBatch = isDesktop ? 10 : 5;
    const [depositsToDisplay, setDepositsToDisplay] = useState([]);
    const depositTypeTransferable = configUtils.get("deposit.depositType.cedip.transferable");
    const depositTypeUntransferable = configUtils.get("deposit.product.untransferable");
    const productTypeTransferable = configUtils.get("deposit.product.transferable");

    useEffect(() => {
        if (deposits?.length) {
            setDepositsToDisplay(deposits.slice(0, depositsPerBatch));
        }
    }, [deposits]);

    const displayNextBatch = () => {
        const lastDepositToInclude = depositsToDisplay.length + depositsPerBatch;
        setDepositsToDisplay(
            deposits.slice(0, deposits?.length < lastDepositToInclude ? deposits.length : lastDepositToInclude),
        );
    };

    const handleDownloadClick = (selectedDeposit) => {
        dispatch(depositsActions.downloadDeposit(selectedDeposit, "pdf"));
    };

    const handleManagementCedipClick = (selectedDeposit) => {};

    const hasAutoRenewal = (autoRenewal) => renewalActions.includes(autoRenewal);

    const depositTypeData = ({ depositType, idProduct, dateInvalid, autoRenewal }) => {
        if (depositType === productTypeTransferable) {
            return {
                text: "deposits.depositType.nonTransferable",
                options: [
                    {
                        text: "deposits.option.cancelRenewal",
                        textType: "I18N",
                        disabled: dateInvalid || !hasAutoRenewal(autoRenewal),
                        func: () => dispatch(routerActions.push(`/deposits/${idProduct}/cancelRenewal`)),
                    },
                ],
            };
        }
        if (depositType === depositTypeUntransferable || depositType === depositTypeTransferable) {
            return {
                text: "deposits.depositType.nonTransferableUSD",
                options: [
                    {
                        text: "deposits.option.cancelRenewal",
                        textType: "I18N",
                        disabled: dateInvalid || !hasAutoRenewal(autoRenewal),
                        func: () => dispatch(routerActions.push(`/deposits/${idProduct}/cancelRenewal`)),
                    },
                ],
            };
        }
        if (depositType === depositTypeTransferable) {
            return {
                text: "",
                options: [
                    {
                        text: "menu.management.cedip",
                        textType: "I18N",
                        func: () => handleManagementCedipClick(idProduct),
                    },
                ],
            };
        }
        return {
            text: "",
            options: [
                {
                    text: "deposits.option.cancelRenewal",
                    textType: "I18N",
                    disabled: dateInvalid || !hasAutoRenewal(autoRenewal),
                    func: () => dispatch(routerActions.push(`/deposits/${idProduct}/cancelRenewal`)),
                },
            ],
        };
    };

    if (!deposits) {
        return (
            <div className="box info service-payments__no-data">
                <Image src="images/information_fill.svg" /> <I18n id="deposits.service.noData" />
            </div>
        );
    }

    const certificateCedip = "82108051010001"; // TODO: Cambiar cuando el servicio retorne el valor del cedip

    return !isEmpty(deposits) ? (
        <>
            {/* <GridTable className="">
                <GridTable.Container columns={isDesktop ? 12 : 4}>
                <GridTable.Data
                columnStart={1}
                columnWidth={isDesktop ? 10 : 2}
                rowStart={isDesktop ?    1 : 1}
                alignX="flex-start"
            alignY="flex-start"> */}
            <TotalInvestedCapital {...{ totalInvestedCapital }} isDesktop={isDesktop} />
            {/* </GridTable.Data>
                </GridTable.Container>
            </GridTable> */}
            <GridTable className="deposits-list">
                {depositsToDisplay.map((deposit) => (
                    <GridTable.Container
                        key={deposit.idProduct}
                        columns={isDesktop ? 8 : 2}
                        rows={isDesktop ? 1 : 3}
                        renderAs={Link}
                        to={`/deposits/${deposit.idProduct}`}>
                        <GridTable.Data columnStart={1} rowStart={1} columnWidth={1} alignX="flex-start" alignY="flex-start">
                            <CustomData
                                titleText="deposits.type"
                                titleTextType="I18N"
                                titleClass="text-Primary-primary-color"
                                valueText={deposit.shortLabel}
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 2 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            columnWidth={2}
                            alignX={isDesktop ? "flex-start" : "center"}
                            alignY={isDesktop ? "flex-start" : "flex-end"}>
                            <CustomData
                                titleText="deposits.expirationDate"
                                titleTextType="I18N"
                                valueText={deposit.dueDateFormatted}
                                valueClass="no-word-break"
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 3 : 1}
                            rowStart={isDesktop ? 1 : 2}
                            columnWidth={1}
                            alignX={isDesktop ? "flex-start" : "flex-end"}
                            alignY="flex-end">
                            <CustomText
                                text={hasAutoRenewal(deposit.autoRenewal) ? "deposits.expirationLabel.auto" : ""}
                                textType="I18N"
                                className="tag tag-success"
                                keepSpaceIfNoText={false}
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 5 : 1}
                            rowStart={isDesktop ? 1 : 3}
                            columnWidth={1}
                            alignX="flex-start"
                            alignY="flex-start">
                            <CustomData
                                titleText="deposits.capitalInvested"
                                titleTextType="I18N"
                                valueText={deposit.amountInvested}
                                valueTextType={deposit.currency}
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 4 : 2}
                            rowStart={isDesktop ? 1 : 2}
                            columnWidth={1}
                            alignX="flex-start"
                            alignY="flex-start">
                            <CustomData
                                titleText="deposits.tna"
                                titleTextType="I18N"
                                valueText={deposit.rate}
                                valueTextType="PERCENTAGE"
                            />
                        </GridTable.Data>
                        <GridTable.Data
                            columnStart={isDesktop ? 6 : 2}
                            rowStart={isDesktop ? 1 : 3}
                            columnWidth={1}
                            alignX="flex-start"
                            alignY="flex-start">
                            <CustomData
                                titleText="deposits.chargeAmount"
                                titleTextType="I18N"
                                valueText={deposit.amountTransfered}
                                valueTextType={deposit.currency}
                            />
                        </GridTable.Data>
                        {deposit.depositType === depositTypeTransferable && (
                            <GridTable.Data
                                columnStart={isDesktop ? 7 : 1}
                                rowStart={isDesktop ? 1 : 4}
                                columnWidth={1}
                                alignX="flex-start"
                                alignY="flex-start">
                                <CustomData
                                    titleText="deposits.certificate.cedip"
                                    titleTextType="I18N"
                                    valueText={certificateCedip}
                                    valueClass="no-word-break"
                                />
                            </GridTable.Data>
                        )}
                        <GridTable.Data
                            columnStart={isDesktop ? 8 : 3}
                            rowStart="1"
                            columnWidth={isDesktop && "1"}
                            alignX={isDesktop ? "flex-start" : "flex-end"}
                            alignY="flex-start">
                            <CustomButton
                                icon="images/figma/icon/menu-mobile.svg"
                                options={[
                                    {
                                        text: "global.download",
                                        textType: "I18N",
                                        func: () => handleDownloadClick(deposit),
                                    },
                                    ...depositTypeData(deposit).options.filter((item) => !item.disabled),
                                ]}
                            />
                        </GridTable.Data>
                    </GridTable.Container>
                ))}
                {deposits?.length > depositsToDisplay.length && (
                    <Button
                        bsStyle="link"
                        onClick={displayNextBatch}
                        image="images/figma/icon/arrow.svg"
                        label="global.showMore"
                        className="view-more"
                    />
                )}
            </GridTable>
        </>
    ) : (
        <EmptyScreenAlert message="echeks.service.noPending" />
    );
};

DepositList.propTypes = {
    deposits: arrayOf(
        shape({
            idEnvironment: number,
            idProduct: string,
            productType: string,
            productTypeLabel: string,
            productTypeShortLabel: string,
            description: string,
            productAlias: string,
            smsAlias: string,
            label: string,
            shortLabel: string,
            extraInfo: string,
            client: shape({
                idClient: string,
                name: string,
            }),
            paperless: string,
            number: string,
            ownerName: string,
            consolidatedAmount: number,
            permissions: string,
            currency: string,
            overdraftLine: number,
            pendingBalance: number,
            balance: number,
            countableBalance: number,
            totalCheckAmount: number,
            nationalIdentifier: string,
            status: string,
            depositNumber: string.isRequired,
            openDate: string,
            dueDate: string.isRequired,
            nextInterestPaymentDate: string,
            rate: number.isRequired,
            nextPaymentAmount: number,
            deadline: number,
            depositType: string.isRequired,
            extraInfoMasked: string,
            amountTransfered: number,
            amountInvested: number.isRequired,
            interest: number,
            autoRenewal: string.isRequired,
            retention: number,
            accreditedAccount: {
                number,
                productType: string,
            },
        }),
    ).isRequired,
    isDesktop: bool.isRequired,
    totalInvestedCapital: shape({ mainCurrency: number, USD: number }).isRequired,
};

const mapStateToProps = (state) => ({
    deposits: depositsSelectors.getDeposits(state),
});
export default connect(mapStateToProps)(DepositList);
